<template>
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.833008"
      width="39"
      height="39"
      rx="19.5"
      stroke="currentColor"
    />
    <path
      d="M10 15.333L18.1649 21.0485C18.8261 21.5113 19.1567 21.7427 19.5163 21.8323C19.8339 21.9115 20.1661 21.9115 20.4837 21.8323C20.8433 21.7427 21.1739 21.5113 21.8351 21.0485L30 15.333M14.8 28.333H25.2C26.8802 28.333 27.7202 28.333 28.362 28.006C28.9265 27.7184 29.3854 27.2595 29.673 26.695C30 26.0532 30 25.2132 30 23.533V17.133C30 15.4529 30 14.6128 29.673 13.971C29.3854 13.4066 28.9265 12.9476 28.362 12.66C27.7202 12.333 26.8802 12.333 25.2 12.333H14.8C13.1198 12.333 12.2798 12.333 11.638 12.66C11.0735 12.9476 10.6146 13.4066 10.327 13.971C10 14.6128 10 15.4529 10 17.133V23.533C10 25.2132 10 26.0532 10.327 26.695C10.6146 27.2595 11.0735 27.7184 11.638 28.006C12.2798 28.333 13.1198 28.333 14.8 28.333Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
